<template>
  <!-- 对话框 -->
  <el-dialog title="扣除签约时长" :visible.sync="show" :before-close="closeDialog" style="width:800px; margin: 0 auto;">

    <!-- 基本信息表单 -->
    <div class="form-box">
      <el-form label-width="80px">

        <el-form-item label="扣除天数:" label-width='120px'>
          <el-input v-model="submit_data.day_num" :placeholder="submit_rules.day_num.placeholder" style="width: 100px;margin-right: 5px;">
          </el-input>天
        </el-form-item>


      </el-form>

      <div style="display: flex;justify-content: center">
        <el-button type="primary" @click="subSigningSubmit">保存</el-button>
        <el-button @click="closeDialog">关闭</el-button>
      </div>

    </div>

  </el-dialog>
</template>

<script>
  var _this;

  export default {
    props: {
      'isShow': Boolean,
      'data': '',
      'driver_or_legwork':''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;
        _this.submit_data.driver_code = _this.data;


      },

    },
    data() {
      return {

        show: false,



        // 表单数据
        submit_data: {
          driver_code: '',
          day_num: ''
        },

        submit_rules: {
          day_num: {
            placeholder: '',
            rules: {
              required: true,
              message: '未输入天数',
              regulation: 'gt_str',
              rulesData: 0
            }
          },

        },

      };
    },
    created() {
      _this = this;

    },
    methods: {

      // 关闭方法
      closeDialog() {

        _this.show = false;

        for (const key in _this.submit_data) {
          _this.submit_data[key] = '';
        }


      },

      // 提交按钮
      subSigningSubmit() {
        // console.log(_this.submit_data);
          var httpURL = ''

        if(this.driver_or_legwork == '0'){
          //  代驾司机
          httpURL = '/driver/subSigningDriverSubmit'
        }else if(this.driver_or_legwork == '1'){
          //  跑腿骑手
          httpURL = '/sign/subSigningLegworkSubmit'
        }

        _this.$post(
                httpURL,
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {
            _this.$message.success({
						message: res.msg,
						duration:1500
					});
            _this.$emit('onSubmit');
            _this.closeDialog();

          }).catch((err) => {

          })

      },


    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }
</style>
